import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain headings preserve
// legacy className behavior across existing screens.
const Heading2 = ({
  id, children, className, tokens, variant
}) => {
  if (!tokens) {
    return (
      <h2 className={`text-xl leading-tight text-h2 font-h2 ${className || ''}`} id={id}>
        {children}
      </h2>
    )
  }

  return (
    <div className={className} id={id}>
      <Typography block heading="h2" variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </div>
  )
}

Heading2.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({})
}

Heading2.defaultProps = {
  variant: { size: 'h2' }
}

export default Heading2
